import { Navigate, useParams } from 'react-router-dom'
import LegalPage, { UnderlinedLink } from './LegalPage'

const OffersTermsPage = () => {
  const { offerID } = useParams()

  // Birthday dessert discount
  if (offerID === 'f55cbd0d-f8a5-4f0a-b753-245547159966') {
    return <Navigate replace to="/legal/birthday-treat" />
  }

  // WAT-1191: Blueprint employee discount - 50% off first meal delivery
  if (offerID === '1f203d35-6967-4200-851a-c828a4725c5a') {
    return (
      <LegalPage heading="Blueprint Employee Discount: 50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid for Blueprint Employees through use of unique offer code
            for new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 50% off your first meal
            delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on September
            29, 2027. Excludes shipping fees (currently $10.99) and taxes
            (varies by state). If you cancel your meal subscription before your
            first meal ships, the discount is forfeited and will not be
            reinstated upon reactivation. Limit one promotional discount per
            household. Tovala reserves the right to disqualify any participant
            suspected of fraud or abuse. No cash value. Offer may not be
            combined with gift cards or other promotions. Offer void outside the
            US and where prohibited by applicable law. Tovala reserves the right
            to end or modify this offer at any time. All subscriptions and meal
            purchases are subject to Tovala's{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              Terms of Service
            </UnderlinedLink>
            ,{' '}
            <UnderlinedLink to="/legal/purchase-terms">
              Purchase Terms
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              Promotional Terms
            </UnderlinedLink>
            .
          </p>
        </div>
      </LegalPage>
    )
  }

  // BACKTOSCHOOL26
  if (offerID === '817b72bd-52b9-41b9-86eb-ef50178a5df5') {
    return (
      <LegalPage heading="50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid through use of unique offer code for new customers only
            with purchase of Tovala Smart Oven and auto-renewing meal
            subscription. Discount of 50% off your first meal delivery is
            automatically applied to your account and must be redeemed by
            placing your first order before 6:00 PM CT on November 4, 2026.
            Excludes shipping fees (currently $10.99) and taxes (varies by
            state). If you cancel your meal subscription before your first meal
            ships, the discount is forfeited and will not be reinstated upon
            reactivation. Limit one promotional discount per household. Tovala
            reserves the right to disqualify any participant suspected of fraud
            or abuse. No cash value. Offer may not be combined with gift cards
            or other promotions. Offer void outside the US and where prohibited
            by applicable law. Tovala reserves the right to end or modify this
            offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // 50% off first meal delivery - August 2026
  if (offerID === '4caf42e9-eb67-429e-be3d-b724644fa011') {
    return (
      <LegalPage heading="50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid through use of unique offer code for new customers only
            with purchase of Tovala Smart Oven and auto-renewing meal
            subscription. Discount of 50% off your first meal delivery
            (estimated value of $54.22) is automatically applied to your account
            and must be redeemed by placing your first order before 6:00 PM CT
            on August 19, 2026. Excludes shipping fees (currently $10.99) and
            taxes (varies by state). If you cancel your meal subscription before
            your first meal ships, the discount is forfeited and will not be
            reinstated upon reactivation. Limit one promotional discount per
            household. Tovala reserves the right to disqualify any participant
            suspected of fraud or abuse. No cash value. Offer may not be
            combined with gift cards or other promotions. Offer void outside the
            US and where prohibited by applicable law. Tovala reserves the right
            to end or modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // firstweek25
  if (offerID === 'ab39196f-0ff1-48e5-ac1c-ce6a599d550e') {
    return (
      <LegalPage heading="25% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid June 25 - August 5, 2026, through use of unique offer
            code for new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 25% off your first meal
            delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on August 5,
            2026. Excludes shipping fees (currently $10.99) and taxes (varies by
            state). If you cancel your meal subscription before your first meal
            ships, the discount is forfeited and will not be reinstated upon
            reactivation. Limit one promotional discount per household. Tovala
            reserves the right to disqualify any participant suspected of fraud
            or abuse. No cash value. Offer may not be combined with gift cards
            or other promotions. Offer void outside the US and where prohibited
            by applicable law. Tovala reserves the right to end or modify this
            offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // easydinners50
  if (offerID === '6f3ef3da-4e44-4acf-aa7c-5fe020fb7ca4') {
    return (
      <LegalPage heading="50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid August 13 - November 4, 2026, through use of unique
            offer code for new customers only with purchase of Tovala Smart Oven
            and auto-renewing meal subscription. Discount of 50% off your first
            meal delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on November
            4, 2026. Excludes shipping fees (currently $10.99) and taxes (varies
            by state). If you cancel your meal subscription before your first
            meal ships, the discount is forfeited and will not be reinstated
            upon reactivation. Limit one promotional discount per household.
            Tovala reserves the right to disqualify any participant suspected of
            fraud or abuse. No cash value. Offer may not be combined with gift
            cards or other promotions. Offer void outside the US and where
            prohibited by applicable law. Tovala reserves the right to end or
            modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // easydinners25
  if (offerID === 'd50efdbe-5640-4437-b46f-1683d22139a1') {
    return (
      <LegalPage heading="25% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid August 13 - November 4, 2026, through use of unique
            offer code for new customers only with purchase of Tovala Smart Oven
            and auto-renewing meal subscription. Discount of 25% off your first
            meal delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on November
            4, 2026. Excludes shipping fees (currently $10.99) and taxes (varies
            by state). If you cancel your meal subscription before your first
            meal ships, the discount is forfeited and will not be reinstated
            upon reactivation. Limit one promotional discount per household.
            Tovala reserves the right to disqualify any participant suspected of
            fraud or abuse. No cash value. Offer may not be combined with gift
            cards or other promotions. Offer void outside the US and where
            prohibited by applicable law. Tovala reserves the right to end or
            modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // Same terms as easydinners25
  if (offerID === 'c2728c5d-a21c-4b63-99ac-ae5c30ce7b19') {
    return (
      <LegalPage heading="25% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid November 19 - December 31, 2026, through use of unique
            offer code for new customers only with purchase of Tovala Smart Oven
            and auto-renewing meal subscription. Discount of 25% off your first
            meal delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on December
            31, 2026. Excludes shipping fees (currently $10.99) and taxes
            (varies by state). If you cancel your meal subscription before your
            first meal ships, the discount is forfeited and will not be
            reinstated upon reactivation. Limit one promotional discount per
            household. Tovala reserves the right to disqualify any participant
            suspected of fraud or abuse. No cash value. Offer may not be
            combined with gift cards or other promotions. Offer void outside the
            US and where prohibited by applicable law. Tovala reserves the right
            to end or modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // firstweek50
  if (offerID === '7f2c7616-1286-4edd-86b8-484b002adb85') {
    return (
      <LegalPage heading="50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid June 25 - August 5, 2026, through use of unique offer
            code for new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 50% off your first meal
            delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on August 5,
            2026. Excludes shipping fees (currently $10.99) and taxes (varies by
            state). If you cancel your meal subscription before your first meal
            ships, the discount is forfeited and will not be reinstated upon
            reactivation. Limit one promotional discount per household. Tovala
            reserves the right to disqualify any participant suspected of fraud
            or abuse. No cash value. Offer may not be combined with gift cards
            or other promotions. Offer void outside the US and where prohibited
            by applicable law. Tovala reserves the right to end or modify this
            offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // bestmeals50
  if (offerID === '1fec3b89-8d7b-469f-a7d0-703b01928964') {
    return (
      <LegalPage heading="50% off your first meal delivery">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid June 17 - July 31, 2026, through use of unique offer
            code for new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 50% off your first meal
            delivery is automatically applied to your account and must be
            redeemed by placing your first order before 6:00 PM CT on July 31,
            2026. Excludes shipping fees (currently $10.99) and taxes (varies by
            state). If you cancel your meal subscription before your first meal
            ships, the discount is forfeited and will not be reinstated upon
            reactivation. Limit one promotional discount per household. Tovala
            reserves the right to disqualify any participant suspected of fraud
            or abuse. No cash value. Offer may not be combined with gift cards
            or other promotions. Offer void outside the US and where prohibited
            by applicable law. Tovala reserves the right to end or modify this
            offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // welcome50 offer
  if (offerID === 'b043a579-d8fc-46e7-a894-cb7a2a6bc3b8') {
    return (
      <LegalPage heading="50% off meals and extras on first order">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid April 25 - May 27, 2026, through use of unique offer
            code for new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 50% off meals and
            extras on your first meal order is automatically applied to your
            account and must be redeemed by placing your first order before 6:00
            PM CT on May 27, 2026. Excludes shipping fees (currently $10.99) and
            taxes (varies by state). If you cancel your meal subscription before
            your first meal ships, the discount is forfeited and will not be
            reinstated upon reactivation. Limit one promotional discount per
            household. Tovala reserves the right to disqualify any participant
            suspected of fraud or abuse. No cash value. Offer may not be
            combined with gift cards or other promotions. Offer void outside the
            US and where prohibited by applicable law. Tovala reserves the right
            to end or modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // 50% off first week of meals April 2026
  if (offerID === 'f5e4408d-4d07-4736-8564-57035252810b') {
    return (
      <LegalPage heading="50% off meals and extras on first order">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid April 8 - 19, 2026, through use of unique offer code for
            new customers only with purchase of Tovala Smart Oven and
            auto-renewing meal subscription. Discount of 50% off meals and
            extras on your first meal order is automatically applied to your
            account and must be redeemed by placing your first order before 6:00
            PM CT on May 13, 2026. Excludes shipping fees (currently $10.99) and
            taxes (varies by state). If you cancel your meal subscription before
            your first meal ships, the discount is forfeited and will not be
            reinstated upon reactivation. Limit one promotional discount per
            household. Tovala reserves the right to disqualify any participant
            suspected of fraud or abuse. No cash value. Offer may not be
            combined with gift cards or other promotions. Offer void outside the
            US and where prohibited by applicable law. Tovala reserves the right
            to end or modify this offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // First week of meals ship free- February Launch Test
  if (offerID === '237a6ec2-fc0d-43c6-8800-166246bf299b') {
    return (
      <LegalPage heading="Free Shipping on your first week of meals">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid through use of unique offer code for new customers only
            with purchase of Tovala Smart Oven and auto-renewing meal
            subscription. Offer is void if auto-renewing meal subscription is
            canceled before shipment of first meal, offer will not be reinstated
            upon any reactivation. Offer expires March 25, 2026, at 6PM CT.
            Offer valid only for free shipping on first meal order ($10.99
            value). Limit one (1) per household. Tovala reserves the right to
            disqualify any participant suspected of fraud or abuse. No cash
            value. Offer may not be combined with gift cards or other
            promotions. Offer void outside the US and where prohibited by
            applicable law. Tovala reserves the right to end or modify this
            offer at any time. Visit{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              https://my.tovala.com/legal/terms-of-service
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              https://my.tovala.com/legal/promotional-terms
            </UnderlinedLink>{' '}
            for more details.
          </p>
        </div>
      </LegalPage>
    )
  }

  // WAT-1180: Accessibility market test - first 4 meals free with oven purchase
  if (offerID === '91d7d93e-279c-4c23-9195-b9727d7fd1e0') {
    return (
      <LegalPage heading="First 4 meals free with oven purchase and auto-renewing meal plan activation">
        <div className="space-y-4 sm:space-y-3">
          <p>
            Offer valid through use of a unique offer code for new customers
            only with purchase of Tovala Smart Oven. Discount of $55.96 off
            (good toward 4 standard single-serving Tovala Meals at $13.99 ea)
            and free shipping ($10.99 value) on your first order is
            automatically applied to your account and must be redeemed by
            activating an auto-renewing meal subscription in the Tovala App or
            at my.tovala.com and placing your first order before 6:00 PM CT on
            September 8, 2027. Excludes taxes (varies by state). Subscriber is
            responsible for the balance of their order in excess of the $55.96
            discount and will only receive 4 free meals if the cost of the meals
            is less than or equal to the $55.96 discount. Activating a meal plan
            enrolls the Subscriber in an auto-renewing subscription at the
            then-current meal plan pricing until they pause or cancel
            deliveries, which they can do at any time through the Tovala App, at
            my.tovala.com, or by contacting Tovala support. All subscriptions
            and meal purchases are subject to Tovala's{' '}
            <UnderlinedLink to="/legal/terms-of-service">
              Terms of Service
            </UnderlinedLink>
            ,{' '}
            <UnderlinedLink to="/legal/purchase-terms">
              Purchase Terms
            </UnderlinedLink>{' '}
            and{' '}
            <UnderlinedLink to="/legal/promotional-terms">
              Promotional Terms
            </UnderlinedLink>
            .
          </p>
          <p>
            If you cancel your meal subscription before your first meal ships,
            the discount is forfeited and will not be reinstated upon
            reactivation. Limit one promotional discount per household. Tovala
            reserves the right to disqualify any participant suspected of fraud
            or abuse. No cash value. Void outside the US and where prohibited by
            law. All offers and prices are subject to change and availability.
            Cannot be used toward gift card purchases or combined with other
            offers. Tovala reserves the right to end or modify this offer at any
            time.
          </p>
        </div>
      </LegalPage>
    )
  }

  return <Navigate replace to="/legal/promotional-terms" />
}

export default OffersTermsPage
